import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ItemAvailabilityStatus } from 'entities/CatalogItem/lib/itemAvailability';
import { FindReplacementLink } from 'shared/ui/FindReplacementLink/FindReplacementLink';

export interface UnavailableTooltipContentProps {
    availabilityStatus?: ItemAvailabilityStatus;
    onLearnMore?: () => void;
    hideReplacementLink?: boolean;
}

export const UnavailableTooltipContent = ({
    availabilityStatus,
    onLearnMore,
    hideReplacementLink = false,
}: UnavailableTooltipContentProps) => {
    const { t } = useTranslation();

    if (availabilityStatus === ItemAvailabilityStatus.NO_SUPPLIERS) {
        return (
            <Box>
                <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, marginBottom: '8px' }}
                >
                    {t('No Longer Available')}
                </Typography>
                <Typography variant="caption" sx={{ mb: '8px' }}>
                    {t(
                        'This item is no longer carried by suppliers. Shop similar items to find alternatives.',
                    )}
                </Typography>
                {!hideReplacementLink && (
                    <FindReplacementLink
                        inline
                        sx={{
                            color: 'inherit',
                            textDecoration: 'underline',
                            fontSize: '1.2rem',
                        }}
                    />
                )}
            </Box>
        );
    }

    return (
        <Box>
            <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, marginBottom: '8px' }}
            >
                {t('Active Supplier Required')}
            </Typography>
            <Typography variant="caption" sx={{ mb: '8px' }}>
                {t(
                    'To add this item, you need an active account with one of the suppliers.',
                )}
            </Typography>
            {onLearnMore && (
                <Link
                    component="button"
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onLearnMore();
                    }}
                    sx={{
                        color: 'inherit',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontSize: '1.2rem',
                    }}
                >
                    {t('Learn more')}
                </Link>
            )}
        </Box>
    );
};
